exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-enter {\n  top: 0px;\n  opacity: 0;\n}\n.modal-enter.modal-enter-active {\n  top: 0px;\n  opacity: 1;\n}\n.modal-leave {\n  top: 0px;\n  opacity: 1;\n}\n.modal-leave.modal-leave-active {\n  top: 0px;\n  opacity: 0;\n  transition: all 200ms;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/Components/Modal/comstyle.css
// module id = 300
// module chunks = 1 2 3 4 5 6